import React, { FunctionComponent } from 'react'
import { Trans } from 'react-i18next'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { Chat } from '../../../organisms/Chat'
import { FullPage } from '../../../templates'

const tKey = TKey('pages.checkout-disabled')

export const CheckoutDisabled: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  const subheader = (
    <Trans i18nKey={tKey('subheader')} t={t} components={{ Chat: <Chat /> }} />
  )

  return (
    <FullPage
      pageId='checkout-disabled'
      header={t(tKey('header'))}
      subheader={subheader}
    />
  )
}
